import { useState, useRef, useEffect } from "react";
import { Auth } from "aws-amplify";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import Toast from "../../utils/Toast";
import LoadingCircle from "../../utils/LoadingCircle";
import { HttpUnAuthApi } from "../../interface/unauth-api";
import { userState } from "../../interface/MainInterface";
import { Checkbox, IconButton, Pagination, PaginationItem, Tooltip, Typography } from "@mui/material";
// import "./SignUp.css";
import { DataGrid, GridColDef, gridPageCountSelector, gridPageSelector, GridPaginationModel, GridRenderCellParams, GridRowSelectionModel, useGridApiRef, useGridSelector } from "@mui/x-data-grid";

import KeyIcon from "@mui/icons-material/Key";
import Delete from "@mui/icons-material/Delete";

interface propsType {
  userState: userState;
}

const unauthApi = new HttpUnAuthApi();

const UserMng = (props: propsType) => {
  const toastRef: any = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const [userId, setUserId] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [userPwdConfirm, setUserPwdConfirm] = useState("");
  const [userName, setUserName] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [needConfirm, setNeedConfirm] = useState(false);
  const [verifyCode, setVerifyCode] = useState("");
  const [realId, setRealId] = useState("");
  const [realPwd, setRealPwd] = useState("");

  const [question, setQuestion] = useState("");
  const [selectedQuestionOption, setSelectedQuestionOption] = useState("name");
  const [showCategory, setShowCategory] = useState(false); // 카테고리 선택 버튼 제어용

  let pageSize: number = 8;
  const gridApi = useGridApiRef();
  const [selectedRow, setSelectedRow] = useState<GridRowSelectionModel>([]);
  const [selectedPage, setSelectedPage] = useState<GridPaginationModel>({ pageSize: pageSize, page: 0 });

  const [userList, setUserList] = useState<any>([]);
  const [rows, setRows] = useState([]);
  const columns: GridColDef[] = [
    {field: 'sk', headerName: 'ID(사번)', headerAlign: "center", align: "center", flex: 1},
    {field: 'name', headerName: "이름", headerAlign: "center", align: "center", flex: 1},
    {field: 'is_admin', headerName: "리포트 생성 권한", headerAlign: "center", align: "center", flex: 1,
      renderCell: (param: GridRenderCellParams) => {
        return (
          <Checkbox
            checked={param.row.is_admin === undefined ? false : param.row.is_admin}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              set_admin_info(e.target.checked, param.row);
            }}
            icon={<img src="/images/list-check-off.png" alt="unchecked" />}
            checkedIcon={<img src="/images/list-check-on.png" alt="checked" />}
          />
        )
      }
    },
    {field: 'is_super_admin', headerName: "관리자 권한", headerAlign: "center", align: "center", flex: 1,
      renderCell: (param: GridRenderCellParams) => {
        return (
          <Checkbox
            checked={param.row.is_super_admin === undefined ? false : param.row.is_super_admin}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              set_super_admin_info(e.target.checked, param.row);
            }}
            icon={<img src="/images/list-check-off.png" alt="unchecked" />}
            checkedIcon={<img src="/images/list-check-on.png" alt="checked" />}
          />
        )
      }
    },
    {field: 'init_passwd', headerName: "패스워드 초기화", headerAlign: "center", align: "center", flex: 0.5,
      renderCell: (param: GridRenderCellParams) => {
        return (
          <>
          <IconButton
            disabled
            onClick={() => {
              reset_user_password(param.row);
            }}
          >
            <Tooltip title="패스워드 초기화">
              {/* <KeyIcon
                className="data-table-img-button"
                color="primary"
              /> */}
              <img src="/images/btn-pwd-reset.png" />
            </Tooltip> 
          </IconButton>
          </>
        )
      }
    },
    {field: 'delete_user', headerName: "삭제", headerAlign: "center", align: "center", flex: 0.5,
      renderCell: (param: GridRenderCellParams) => {
        return (
          <IconButton
            disabled
            onClick={() => {
              delete_user(param.row);
            }}
          >
            <Tooltip title="사용자 삭제">
              {/* <Delete
                className="data-table-img-button"
                color="error"
              /> */}
              <img src="/images/svg-delete.svg" />
            </Tooltip>
          </IconButton>
        )
      }
    }
  ];

  useEffect(() => {
    get_user_list(); 
    return () => {
      setIsLoading(false);
      setUserId("");
      setUserEmail("");
      setUserPwd("");
      setUserPwdConfirm("");
      setUserName("");
      setUserCompany("");
      setNeedConfirm(false);
      setVerifyCode("");
      setRealId("");
      setRealPwd("");
      setSelectedRow([]);
      setSelectedPage({ pageSize: pageSize, page: 0 });
    };
  }, []);

  useEffect(() => {
    if (question === "") {
      setRows(userList);
    } else {
      const filteredList = userList.filter((item: any) => {
        const value = item[selectedQuestionOption];
        return value && typeof value === "string" && value.includes(question);
      });
      setRows(filteredList);
    }
  }, [userList, selectedQuestionOption, question]);

  const fncSignUp = async () => {
    if (userId === "" || userId === undefined) {
      toastRef.current?.toast("아이디를 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }
    if (userEmail === "" || userEmail === undefined) {
      toastRef.current?.toast("이메일을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }
    if (userPwd === "" || userPwd === undefined) {
      toastRef.current?.toast("패스워드를 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }
    if (userPwd !== userPwdConfirm) {
      toastRef.current?.toast("패스워드가 일치하지 않습니다.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }
    if (userName === "" || userName === undefined) {
      toastRef.current?.toast("이름을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }

    setRealId(userId);
    setRealPwd(userPwd);

    setIsLoading(true);
    const param: any = {
      id: userId,
      email: userEmail,
      password: userPwd,
      name: userName,
      company: userCompany,
    };

    const res = await unauthApi.create_user(param);
    if (res.code === "200") {
      toastRef.current?.toast("입력하신 이메일로 발송된 인증코드를 입력하세요", "success", 4000, { vertical: "top", horizontal: "center" });
      setNeedConfirm(true);
    } else {
      if (res.code === "201" || res.code === "202") alert(`${res.response.error_msg}`);
      else alert(`알수 없는 에러가 발생했습니다.\n- CODE : ${res.code}\n- message : ${res.response.error_msg}`);
    }
    setIsLoading(false);
  };

  const fncConfirm = async () => {
    if (verifyCode === "" || verifyCode === undefined) {
      toastRef.current?.toast("인증번호를 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }

    try {
      await Auth.confirmSignUp(realId, verifyCode);
      toastRef.current?.toast("인증에 성공했습니다.", "success", 4000, { vertical: "top", horizontal: "center" });
      // autoSignIn();
      setNeedConfirm(false);
      setUserId("");
      setUserEmail("");
      setUserPwd("");
      setUserPwdConfirm("");
      setUserName("");
      get_user_list();
    } catch (error: any) {
      toastRef.current?.toast("인증번호가 맞지않습니다.", "error", 4000, { vertical: "top", horizontal: "center" });
    }
  };

  const handleVerifyCodeEnter = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") fncConfirm();
  };

  const autoSignIn = async () => {
    if (realId === "" || realId === undefined) {
      toastRef.current?.toast("이메일을 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }
    if (realPwd === "" || realPwd === undefined) {
      toastRef.current?.toast("패스워드를 입력하세요.", "error", 4000, { vertical: "top", horizontal: "center" });
      return;
    }

    try {
      await Auth.signIn(realId, realPwd);
      window.location.href = "/";
    } catch (error: any) {}
  };

  const fncResendCode = async () => {
    try {
      await Auth.resendSignUp(realId);
      toastRef.current?.toast("인증번호를 발송했습니다.", "success", 4000, { vertical: "top", horizontal: "center" });
    } catch (err) {
      console.error("error resending code: ", err);
    }
  };

  const get_user_list = async () => {
    const param: any = {
      command: "get_user_list",
      user_id: props.userState.id,
    }

    setIsLoading(true);
    const res = await unauthApi.post(param);
    if (res.code === "200") {
      setUserList(res.response.user_list);
      // console.log("user_list ", res.response.user_list);
    } else {
      console.error(res.response.error_msg);
      toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      }); 
    }
    setIsLoading(false);
  }

  const set_admin_info = async (add_admin: boolean, userInfo: any) => {
    // 수정권한 확인
    if (!props.userState.isSuperAdmin) {
        toastRef.current?.toast("권한부여 권한이 없습니다.", "error", 4000, {
            vertical: "top",
            horizontal: "center",
        });
        return;
    }
    let comfirmText = "해당 계정에 리포트 생성 권한을 부여하시겠습니까?";
    if (!add_admin) {
        comfirmText = "해당 계정에 리포트 생성 권한을 해제하시겠습니까?";
    }

    if (!window.confirm(comfirmText)) return;

    setIsLoading(true);
    const param: any = {
        command: "set_admin_info",
        user_id: props.userState.id,
        target_user_info: {
            pk: userInfo.pk,
            sk: userInfo.sk,
            is_admin: add_admin,
        },
    };

    const res = await unauthApi.post(param);
    if (res.code === "200") {
        get_user_list();
    } else {
        console.error(res.response.error_msg);
        toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
            vertical: "top",
            horizontal: "center",
        });
    }
    setIsLoading(false);
  };

  const set_super_admin_info = async (add_super_admin: boolean, userInfo: any) => {
    // 수정권한 확인
    if (!props.userState.isSuperAdmin) {
        toastRef.current?.toast("권한부여 권한이 없습니다.", "error", 4000, {
            vertical: "top",
            horizontal: "center",
        });
        return;
    }
    let comfirmText = "해당 계정에 관리자 권한을 부여하시겠습니까?";
    if (!add_super_admin) {
        comfirmText = "해당 계정에 관리자 권한을 해제하시겠습니까?";
    }

    if (!window.confirm(comfirmText)) return;

    setIsLoading(true);
    const param: any = {
        command: "set_super_admin_info",
        user_id: props.userState.id,
        target_user_info: {
            pk: userInfo.pk,
            sk: userInfo.sk,
            is_super_admin: add_super_admin,
        },
    };

    const res = await unauthApi.post(param);
    if (res.code === "200") {
        get_user_list();
    } else {
        console.error(res.response.error_msg);
        toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
            vertical: "top",
            horizontal: "center",
        });
    }
    setIsLoading(false);
  };

  const reset_user_password = async (target_user_info: any) => {
    if (!window.confirm("해당 사용자의 패스워드를 초기화합니다.")) return;

    const param: any = {
      command: "reset_user_password",
      user_id: props.userState.id,
      target_user_info: {
        pk: target_user_info.pk,
        sk: target_user_info.sk,
      },
    };

    const res = await unauthApi.post(param);
    if (res.code === "200") {
      toastRef.current?.toast(res.response.msg, "success", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    } else {
      console.error(res.response.error_msg);
      toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
  }

  const delete_user = async (target_user_info: any) => {
    if (!window.confirm("해당 사용자를 삭제하시겠습니까?삭제한 데이터는 복구할 수 없습니다.")) return;

    setIsLoading(true);
    const param: any = {
      command: "delete_user",
      user_id: props.userState.id,
      target_user_info: {
        pk: target_user_info.pk,
        sk: target_user_info.sk,
      },
    };

    const res = await unauthApi.post(param);
    if (res.code === "200") {
      get_user_list();
    } else {
      console.error(res.response.error_msg);
      toastRef.current?.toast("" + res.response.error_msg, "error", 4000, {
        vertical: "top",
        horizontal: "center",
      });
    }
    setIsLoading(false);
  };

  const handleSelectOptionChange = (event: any) => {
    setSelectedQuestionOption(event.target.value);
    };

function CustomPagination() {
    const page = useGridSelector(gridApi, gridPageSelector);
    const pageCount = useGridSelector(gridApi, gridPageCountSelector);
    return (
      <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
        <Pagination
          color="primary"
          shape="rounded"
          count={pageCount === 0 ? 1 : pageCount}
          page={page + 1}
          siblingCount={3}
          onChange={(e, v) => gridApi.current.setPage(v - 1)}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              // next 버튼을 커스터마이즈
              components={{
                previous: (props) => (
                  <Stack direction="row" gap={2}>
                    <Typography sx={{ fontWeight: 500, fontSize: "13px", color: '#2A2A2A' }}>이전</Typography>
                    <img src="images/btn-ghost-prev.png" alt="Prev" {...props} />
                  </Stack>
                ),
                next: (props) => (
                  <Stack direction="row" gap={2}>
                    <img src="images/btn-ghost-next.png" alt="Next" {...props} />
                    <Typography sx={{ fontWeight: 500, fontSize: "13px", color: '#2A2A2A' }}>다음</Typography>
                  </Stack>
                ),
              }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center',
                textDecorationLine: item.selected ? 'underline' : 'none',
                color: item.selected ? '#2A2A2A' : '#B1B1B1',
                userSelect: 'none',
                backgroundColor: 'transparent', // 배경 투명
                border: 'none', // 테두리 없음
                boxShadow: 'none', // 그림자 없음
                fontWeight: 500,
                minWidth: "23px",
                '&:hover': {
                  backgroundColor: 'transparent', // 호버 시 배경 투명
                },
                '&.Mui-selected': {
                  backgroundColor: 'transparent', // 선택된 상태 배경 제거
                  color: '#2A2A2A', // 선택된 상태 색상
                },
              }}
            />
          )}
        ></Pagination>
      </Box>
    );
  };


  return (
    <>
      <section id="commWrap" style={{ padding: "99px 0px 0px"}}>
        <Stack direction="row" gap={5}>
            {needConfirm ? (
            <Stack direction="column" sx={{ justifyContent: "flex-start" }}>
                <Box
                sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center", 
                    pb: 5,
                }}
                >
                <Typography sx={{ fontWeight: 700, fontSize: "1.25rem" }}>이메일 인증</Typography>
                </Box>
                <Stack className="login-input-wrap" spacing={0.5} direction="column">
                <Typography className="login-input-txt">
                    인증번호 입력
                </Typography>
                <TextField
                    id="txtVerifyCode"
                    className="login-input"
                    value={verifyCode}
                    placeholder="인증번호를 입력해주세요."
                    variant="outlined"
                    autoFocus
                    fullWidth
                    required
                    type="search"
                    autoComplete="off"
                    inputProps={{ enterKeyHint: "Enter", style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                    setVerifyCode(e.target.value);
                    }}
                    onKeyDown={(e) => {
                    handleVerifyCodeEnter(e);
                    }}
                    sx={{ width: "17.5rem", height: "50px", borderRadius: 5 }}
                />
                </Stack>
                <Box className="login-btn-wrap" sx={{ width: "17.5rem" }}>
                <Button onClick={fncConfirm} sx={{ fontSize: "16px" }}>인증하기</Button>
                </Box>
                <Button sx={{ color: "#2a2a2a", fontWeight: 700, mt: '20px' }} onClick={fncResendCode}>
                인증번호 재발송
                </Button>
            </Stack>
            ) : (
            <Stack direction="column" sx={{ justifyContent: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center", 
                    pb: 5,
                  }}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "1.25rem" }}>신규 계정 생성</Typography>
                </Box>
                <Stack className="login-input-wrap" spacing={0.5} direction="column">
                <Typography className="login-input-txt">
                    아이디
                </Typography>
                <TextField
                    id="signUpId"
                    className="login-input"
                    value={userId}
                    placeholder="아이디를 입력해주세요."
                    variant="outlined"
                    autoFocus
                    fullWidth
                    required
                    type="search"
                    autoComplete="off"
                    inputProps={{ enterKeyHint: "Enter", style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                    setUserId(e.target.value);
                    }}
                    sx={{ width: "17.5rem", height: "50px", borderRadius: 5 }}
                />
                </Stack>
                <Stack className="login-input-wrap" spacing={0.5} direction="column">
                <Typography className="login-input-txt">
                    이메일
                </Typography>
                <TextField
                    id="signUpEmail"
                    className="login-input"
                    value={userEmail}
                    placeholder="이메일을 입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="search"
                    autoComplete="off"
                    inputProps={{ enterKeyHint: "Enter", style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                    setUserEmail(e.target.value);
                    }}
                    sx={{ width: "17.5rem", height: "50px", borderRadius: 5 }}
                />
                </Stack>
                <Stack className="login-input-wrap" spacing={0.5} direction="column">
                <Typography className="login-input-txt">
                    패스워드
                </Typography>
                <TextField
                    id="signUpPwd"
                    className="login-input"
                    value={userPwd}
                    placeholder="패스워드를 입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="password"
                    autoComplete="current-password"
                    inputProps={{ autoComplete: "new-password", enterKeyHint: "Enter", style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                    setUserPwd(e.target.value);
                    }}
                    sx={{ width: "17.5rem", height: "50px", borderRadius: 5 }}
                />
                </Stack>
                <Stack className="login-input-wrap" spacing={0.5} direction="column">
                <Typography className="login-input-txt">
                    패스워드 확인
                </Typography>
                <TextField
                    id="signUpPwdComfirm"
                    className="login-input"
                    value={userPwdConfirm}
                    placeholder="패스워드를 다시 입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="password"
                    autoComplete="current-password"
                    inputProps={{ autoComplete: "new-password", enterKeyHint: "Enter", style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                    setUserPwdConfirm(e.target.value);
                    }}
                    sx={{ width: "17.5rem", height: "50px", borderRadius: 5 }}
                />
                </Stack>
                <Stack className="login-input-wrap" spacing={0.5} direction="column">
                <Typography className="login-input-txt">
                    이름
                </Typography>
                <TextField
                    id="signUpName"
                    className="login-input"
                    value={userName}
                    placeholder="이름을 입력해주세요."
                    variant="outlined"
                    fullWidth
                    required
                    type="search"
                    autoComplete="off"
                    inputProps={{ enterKeyHint: "Enter", style: { padding: "12px 16px 10px 16px" } }}
                    onChange={(e) => {
                    setUserName(e.target.value);
                    }}
                    sx={{ width: "17.5rem", height: "50px", borderRadius: 5 }}
                />
                </Stack>
                <Box className="login-btn-wrap" style={{ width: "17.5rem" }}>
                <Button onClick={fncSignUp} sx={{ fontSize: "16px" }}>계정 생성하기</Button>
                </Box>
            </Stack>
            )}

          {/* 계정관리 */}
          <Stack direction="column" sx={{ width: "100%", justifyContent: "center" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center", 
                pb: 5,
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: "1.25rem" }}>계정관리</Typography>
            </Box>
            <div className="user-list-wrap">
              <div className="option-wrap">
                <Stack direction="row" gap={2}>
                  <div className="category">
                    <div className={showCategory ? "user_select_wrap active" : "user_select_wrap"} >
                      <ul className="default_option">
                        <li
                          onClick={() => {
                            setShowCategory(!showCategory);
                          }}
                        >
                          {selectedQuestionOption === "sk" ? "ID" : "이름"}
                        </li>
                      </ul>
                      <ul className="select_ul">
                        <li 
                          onClick={() => {
                            setSelectedQuestionOption("sk");
                          }}
                        >
                          ID
                        </li>
                        <li 
                          onClick={() => {
                            setSelectedQuestionOption("name");
                          }}
                        >
                          이름
                        </li>
                      </ul>
                    </div>
                  </div> 
                  <div className="keyword">
                    <input
                      style={{ width: "240px" }}
                      type="text"
                      placeholder="검색어 입력"
                      value={question}
                      onChange={(e) => {
                        setQuestion(e.target.value);
                      }}
                    />
                  </div>
                </Stack>
              </div>
            </div>
              <DataGrid
                apiRef={gridApi}
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                        pageSize: pageSize,
                    },
                  },
                }}
                disableColumnMenu
                slots={{ pagination: CustomPagination }}
                hideFooterSelectedRowCount
                getRowId={(row) => row.sk}
                rowSelectionModel={selectedRow}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                  setSelectedRow(newRowSelectionModel);
                }}
                paginationModel={selectedPage}
                onPaginationModelChange={(newPagenationModel) => {
                  setSelectedPage(newPagenationModel);
                }}
                columnHeaderHeight={44}
                rowHeight={44}
                sx={{ 
                  mt: 2,
                  border: 'none',
                  borderRadius: '0px',
                  height: 44 * 9, // 고정 높이 설정: 8개의 행 + 헤더 높이 + 페이지네이션 높이
                  "& .MuiDataGrid-columnHeaders": { backgroundColor: "#F5F5F5", borderColor: '#000' },
                  "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 700, fontSize: '14px' },
                  "& .MuiDataGrid-footerContainer": { borderTop: 'none' },
                }}
              />
          </Stack>
        </Stack>
      </section>
      <Toast ref={toastRef} />
      {/* <LoadingCircle loading={isLoading} /> */}
    </>
  );
};

export default UserMng;
